























































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import draggable from 'vuedraggable'
import KeyAreaSkill from '@/domain/drd-2.0/entity/key-area-skill.entity';
import Skill from '@/domain/drd-2.0/entity/skill.entity';
import SkillNodeComponent from './skill-node.component.vue';

@Component({
  name: 'SkillTreeComponent',
  components: {
    SkillNodeComponent,
    draggable,
  },
})
export default class SkillTreeComponent extends Vue {
  @Prop() skills!: KeyAreaSkill[];

  @Prop() skillOptions!: any;

  @Prop({ type: String, default: 'PTBR' }) languageSelected!: string;

  @Prop({ type: Array, default: [] }) languageOptions!: any[];

  @Prop({ type: Number, default: 0 }) hiearchyLevel!: number;

  search: string = '';

  page: number = 1;

  pageSize: number = 10;

  loadingMore: boolean = false;

  get filteredSkills() {
    if (!this.search) return this.skills;
    return this.skills.filter(s => s.skill.whatPTBR && s.skill.whatPTBR.toLowerCase()
      .includes(this.search.toLowerCase()));
  }

  get paginatedSkills() {
    return this.filteredSkills.slice(0, this.page * this.pageSize);
  }

  handleScroll(e: Event) {
    const el = (e.target as HTMLElement);
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !this.loadingMore) {
      this.loadMore();
    }
  }

  loadMore() {
    if (this.paginatedSkills.length < this.filteredSkills.length) {
      this.loadingMore = true;
      setTimeout(() => {
        this.page += 1;
        this.loadingMore = false;
      }, 300);
    }
  }

  @Watch('search')
  onSearchChanged() {
    this.page = 1;
  }

  get dragOptions() {
    return {
      animation: 200,
      disabled: false,
      ghostClass: 'ghost',
      scroll: true,
      scrollEl: this.$refs.drawer,
      scrollSensitivity: 300,
      scrollSpeed: 5,
      onStart: () => {
        document.addEventListener('wheel', this.allowScroll, {
          passive: false,
        });
      },
      onEnd: () => {
        document.removeEventListener('wheel', this.allowScroll);
      },
    };
  }

  allowScroll(e: WheelEvent) {
    // não previne nada → navegador continua rolando
    // se quiser controlar, pode manipular aqui
  }

  getBackgroundColor(hiearchyLevel: number) {
    const colors = [
      'rgb(255 255 255)',
      'rgb(248 250 252)',
      'rgb(239 246 255)',
      'rgb(238 242 255)',
      'rgb(250 245 255)',
      'rgb(253 242 248)',
    ]
    return colors[hiearchyLevel % colors.length]
  }

  handleUpdateSkill(skill: Skill) {
    this.skills.filter(s => s.skill.id === skill.id)[0].skill = skill;
  }

  moveSkillUp(skillId: string) {
    const idx = this.skills.findIndex(s => s.skill.id === skillId);
    if (idx > 0) {
      const temp = this.skills[idx - 1];
      this.$set(this.skills, idx - 1, this.skills[idx]);
      this.$set(this.skills, idx, temp);
      this.$emit('updateSkills', [...this.skills]);
    }
  }

  moveSkillDown(skillId: string) {
    const idx = this.skills.findIndex(s => s.skill.id === skillId);
    if (idx < this.skills.length - 1) {
      const temp = this.skills[idx + 1];
      this.$set(this.skills, idx + 1, this.skills[idx]);
      this.$set(this.skills, idx, temp);
      this.$emit('updateSkills', [...this.skills]);
    }
  }

  setSkillPosition({ skillId, position }: { skillId: string, position: number }) {
    const idx = this.skills.findIndex(s => s.skill.id === skillId);
    if (idx === -1 || position < 0 || position >= this.skills.length || idx === position) return;
    const skill = this.skills.splice(idx, 1)[0];
    this.skills.splice(position, 0, skill);
    this.$emit('updateSkills', [...this.skills]);
  }
}
